import React from 'react';
import { LazyScreen } from '@apps/guest/packages/layout-engine/components/CoverPhoto/CoverPhoto';
import { CoverPhotoContainer, StyledCoverPhoto } from '@apps/guest/packages/layout-engine/components/CoverPhoto/CoverPhoto.styles';
import { getImageRendition } from '@apps/guest/packages/layout-engine/layouts/layout.utils';
import type { WebsiteHeaderPhotoWithAlignment } from '@shared/types/WebsiteHeaderSettings.types';
import { Box } from '@withjoy/joykit';

interface CenterPhotoProps {
  photo?: WebsiteHeaderPhotoWithAlignment;
  showPlaceholder?: boolean;
}

export const CenterPhoto = (props: CenterPhotoProps) => {
  const { photo, showPlaceholder } = props;

  if (!photo) {
    return showPlaceholder ? (
      <Box
        width="100%"
        height={600}
        display="flex"
        justifyContent="center"
        alignItems="center"
      >
        <Box
          width="80%"
          height={600}
          backgroundColor="lightgray"
        />
      </Box>
    ) : null;
  }

  return (
    <LazyScreen
      src={photo.url}
      width={(600 * photo.width) / photo.height}
      height={600}
      isFullBleed={false}
      isChildEagerLoadRequire={false}
    >
      {() => {
        return (
          <CoverPhotoContainer
            photo={photo}
            position={'relative'}
            maxWidth={{ _: '100%', md2: '83%' }}
            marginX={{ md2: 'auto' }}
            maxHeight={[null, null, null, 600]}
            width={'100%'}
          >
            <StyledCoverPhoto
              backgroundSize={'contain'}
              url={getImageRendition(photo.url)}
            />
          </CoverPhotoContainer>
        );
      }}
    </LazyScreen>
  );
};
